import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { AuthenticationService } from './authentication.service';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1; // Remove this line to use Angular Universal

export function loggerCallback(logLevel: LogLevel, message: string) {
  //  console.log(message);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read'],
    },
    loginFailedRoute: '/logout',
  };
}

export function MSALInstanceFactory(
  authenticationService: AuthenticationService,
): IPublicClientApplication {
  return new PublicClientApplication({
    auth: authenticationService.getAuthConfig(),
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(
  authenticationService: AuthenticationService,
): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  if (authenticationService?.authConfig?.scope) {
    protectedResourceMap.set(authenticationService.authConfig.apiUrl + '*', [
      authenticationService.authConfig.scope,
    ]);
    // protectedResourceMap.set(
    //   authenticationService.authConfig.chatBotUrl + '*',
    //   [authenticationService.authConfig.scope],
    // );
  }
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', [
    'User.Read',
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
